import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import styles from './SchoolPortfolio.module.css';

interface SchoolProject {
  id: string;
  month: string;
  rocnik: string | null;
  title: string;
  description: string;
  image: string | null;
  created_at: string;
}

const monthOrder = [
  'září',
  'říjen',
  'listopad',
  'prosinec',
  'leden',
  'únor',
  'březen',
  'duben',
  'květen',
  'červen',
];

export const SchoolPortfolio = () => {
  const [projects, setProjects] = useState<SchoolProject[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState('3.');
  const navigate = useNavigate();
  // const guardRef = useRef(false);

  useEffect(() => {
    

    loadProjects();
  }, [navigate]);

  const loadProjects = async () => {
    try {
      const { data, error } = await supabase
        .from('school_portfolio_entries')
        .select('*')
        .order('created_at', { ascending: false });

      if (!error) {
        setProjects(data || []);
      }
    } catch (err) {
      console.error('Chyba při načítání projektů:', err);
    } finally {
      setLoading(false);
    }
  };

  const filteredProjects = projects
    .filter((p) => (p.rocnik || '').trim() === selectedYear)
    .sort((a, b) => {
      const aIdx = monthOrder.indexOf(a.month);
      const bIdx = monthOrder.indexOf(b.month);
      return (aIdx === -1 ? 999 : aIdx) - (bIdx === -1 ? 999 : bIdx);
    });

  return (
    <div className={styles.schoolPortfolio}>
      <h1 className={styles.title}>Moje Portfolio</h1>

      <p className={styles.cv}>Můj životopis: <a href="/zivotopiscj.pdf" target='_blank'>Životopis  </a></p>

      <div className={styles.controls}>
        <span className={styles.label}>Ročník</span>
        <div className={styles.yearSwitcher}>
          <button
            type="button"
            className={styles.yearButton}
            onClick={() =>
              setSelectedYear((prev) => {
                const n = Number(prev);
                return n <= 1 ? '4.' : String(n - 1)+".";
              })
            }
            aria-label="Předchozí ročník"
          >
            ←
          </button>
          <span className={styles.yearValue}>{selectedYear}</span>
          <button
            type="button"
            className={styles.yearButton}
            onClick={() =>
              setSelectedYear((prev) => {
                const n = Number(prev);
                return n >= 4 ? '1.' : String(n + 1)+".";
              })
            }
            aria-label="Další ročník"
          >
            →
          </button>
        </div>
      </div>

      {loading ? (
        <p style={{ textAlign: 'center', color: '#999' }}>Načítám projekty...</p>
      ) : filteredProjects.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#999' }}>
          Pro tento ročník zatím nejsou žádné zápisy.
        </p>
      ) : (
        <div className={styles.grid}>
          {filteredProjects.map((project) => (
            <Link
              key={project.id}
              to={`/school-project/${project.id}`}
              className={styles.itemLink}
            >
              <div className={styles.item}>
                <div className={styles.itemImage}>
                  {project.image ? (
                    <img src={project.image} alt={project.title} />
                  ) : (
                    <span>{project.month.toUpperCase()}</span>
                  )}
                  <div className={styles.badge}>{project.month.toUpperCase()}</div>
                </div>
                <div className={styles.itemContent}>
                  <h2 className={styles.itemTitle}>{project.title}</h2>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
